<template>
    <section class="intro-list">
        <intro-item :title="$t('message.goods.skuSpec')" :content="skuText" @handle-click="showSku" icon />
        <intro-item v-if="cityName" :title="$t('message.goods.pointOrgin')" :content="cityName" />
        <!-- <intro-item v-if="serve" :title="$t('message.goods.serve')" :content="serve" /> -->
        <intro-item v-if="drections" :title="$t('message.goods.explain')" :content="drections" />
    </section>
</template>
<script>
import IntroItem from '@/components/goods/introItem'
export default {
    data(){
        return {
            
        }
    },
    components: {
        IntroItem
    },
    props: {
        cityName: String,
        serve: String,
        drections: String,
        skuText: String,
        goodsId: String
    },
    methods: {
        showSku() {
            this.$isLogin(function () {
                this.$emit('place-an-order');
           }.bind(this));
        }
    }
};
</script>
<style lang="less" scoped>
    .intro-list {
        margin-top: 6px;
        padding: 0 12px;
        background-color: #fff;
    }
</style>
